import { useEffect, useState } from "react"
import _map from "lodash/map"
import _flattenDeep from "lodash/flattenDeep"
import _find from "lodash/find"

export const useSVAStatus = (customer, getSVAs) => {
  const [showOnlineInterface, setShowOnlineInterface] = useState(false)

  useEffect(() => {
    if (customer && customer.customerId) {
      findSVAsList()
    }
  }, [customer, getSVAs])

  const findSVAsList = async () => {
    try {
      const response = await getSVAs(customer.customerId)
      if (!response.payload) return

      const assetList = response.payload.data.assetList || []

      const svaAssetList = _flattenDeep(
        _map(assetList, (item) => item.svaAssetList || [])
      )

      const svaAsset = _find(
        svaAssetList,
        (item) =>
          item.assetProductId === 1775 ||
          item.assetProductId === 1776 ||
          item.assetProductId === 1778
      )

      if (svaAsset) {
        setShowOnlineInterface(true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return showOnlineInterface
}



// WEBPACK FOOTER //
// ./src/hooks/useSVAStatus.js